import script from "./ConfluenceHomeScreenOwners.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceHomeScreenOwners.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceHomeScreenOwners.vue?vue&type=style&index=0&id=06493083&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06493083"]])

export default __exports__